import ChangeForgotPasswordFormContainer from "./change-forgot-password-container";

export default ChangeForgotPasswordFormContainer;